<template>
  <b-container>
    <h3>{{ getContentItem("invoicesButton") }}</h3>
    <DnTable
      class="blue"
      stacked="md"
      hover
      striped
      show-empty
      :busy="isInvoicesLoading"
      :items="invoices"
      :fields="InvoiceResultsColumns"
      :no-provider-filtering="true"
      :no-provider-sorting="true"
      :no-provider-paging="true"
    >
      <template #InvoiceNumber="{ row }">
        <router-link
          :to="{ name: 'InvoiceDetails', query: { invoiceId: row.item.Id, invoiceSource: row.item.InvoiceSource }}"
        >
          {{ row.item.InvoiceNumber }}
        </router-link>
      </template>
      <template #SubTotalFreight="{ row }">
        <currency-text v-if="!hasPermission('HideInvoicePricing')" :amount="row.item.SubTotalFreight" :currency-code="row.item.CurrencyCode" />
      </template>
      <template #TotalInvoice="{ row }">
        <currency-text v-if="!hasPermission('HideInvoicePricing')" :amount="row.item.TotalInvoice" :currency-code="row.item.CurrencyCode" />
      </template>
      <template #empty>
        <div v-if="isInvoicesLoading" class="d-flex justify-content-center">
          <loading-spinner />
        </div>
      </template>
    </DnTable>
  </b-container>
</template>

<script>
  import { mapGetters } from "vuex";

  import { ErrorLogService } from "@/services/ErrorLogService";
  import { InvoiceService } from "@/services/InvoiceService";
  import { OrderService } from "@/services/OrderService";
  import { BackorderService } from "@/services/BackorderService";

  import { stringHelper } from "@/components/mixins/stringHelper";
  import { formatDateTime } from "@/components/mixins/formatDateTime";

  import CurrencyText from "@/components/Elements/CurrencyText";
  import LoadingSpinner from "@/components/Elements/LoadingSpinner"

  import OrdersMenu from "@/components/SubMenus/OrdersMenu";
  import OrdersSearchWidgetForm from "@/components/SubMenus/OrdersSearchWidgetForm";
  import DnTable from "@/components/Elements/DnTable/DnTable.vue";

  export default {
    components: {
      CurrencyText,
      LoadingSpinner,
      DnTable
    },
    mixins: [stringHelper, formatDateTime],
    props: {
      documentNumber: {
        type: String,
        default: ""
      },
      partNumber: {
        type: String,
        default: ""
      },
      dealerCodes: {
        type: Array,
        default: () => []
      },
    },
    data: () => ({
      InvoiceResultsColumns: [
        {
          key: "InvoiceDate",
          localizationKey: "date",
          formatter: "formatDateTime"
        },
        { key: "InvoiceNumber", localizationKey: "invoiceNumber" },
        { key: "ShipVia", localizationKey: "shipVia" },
        { key: "SalesOrganization", localizationKey: "salesOrg" },
        { key: "PurchaseOrderNumber", localizationKey: "poNumber" },
        { key: "SubTotalFreight", localizationKey: "freight" },
        { key: "TotalInvoice", localizationKey: "total" }
      ],
      isInvoicesLoading: true,
      invoices: []
    }),
    computed: {
      ...mapGetters(["getContentItem", "activeAccountId", "user", "hasPermission"]),
      SearchKeyword() {
        return this.documentNumber ? this.documentNumber : this.partNumber;
      }
    },
    mounted() {
      this.InvoiceSearch();
      this.InvoiceResultsColumns = this.InvoiceResultsColumns.map(column => {
        if (typeof column === "object") {
          return Object.assign({}, column, {
            label: this.getContentItem(column.localizationKey)
          });
        }
        return column;
      });
    },
    watch: {
      documentNumber() {
        this.InvoiceSearch();
      },
      partNumber() {
        this.InvoiceSearch();
      },
      dealerCodes() {
        this.InvoiceSearch();
      },
    },
    methods: {
      InvoiceSearch() {       
        var dealerCodesToSearch = JSON.parse(JSON.stringify( this.dealerCodes ));
        
        // clear out any existing invoices because we will be concatenating results if there are more than 100 dealers
        this.invoices = [];
        const seenInvoiceIds = new Set();
        
        while(dealerCodesToSearch.length) {
          this.isInvoicesLoading = true
          var dealersToSearchUpTo100 = dealerCodesToSearch.splice(0,100);

          InvoiceService.SearchInvoicesByDocumentOrPart(
            this.activeAccountId,
            this.user.UserId,
            this.partNumber,
            this.documentNumber,
            dealersToSearchUpTo100
          )
            .then(response => {
              // Deduplicate invoices by ID
              response.data.forEach(invoice => {
                if (!seenInvoiceIds.has(invoice.Id)) {
                  seenInvoiceIds.add(invoice.Id);
                  this.invoices.push(invoice);
                }
              });
            })
            .catch(err => {
              ErrorLogService.LogException(err);
              return [];
            })
            .finally(() => {
              this.isInvoicesLoading = false
            });
        }
     }
    }
  };
</script>
